<ng-container>
    <ng-container>
        <div class="w-100 float-left mt-3">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> Column Header </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> Display Name </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> Type </h6>
                </div>
                <div *ngIf="isStarSchema" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> Dimension </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> Default Time Filter </h6>
                </div>
            </div>
        </div>

        <div *ngFor="let rff of analyticalModelData.fact.recordFormatFieldData; index as i"
             class="w-100 float-left p-md-2 grid-details">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 text-truncate">{{rff.fieldName}}</h6>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                <h6 class="mb-lg-0 text-truncate">{{rff.displayName}}</h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <select class="form-control p-1" (change)="onChangeOfType($event, rff,i)">
                    <option [attr.selected]="(!cubeMesMap.has(rff.refId) || !cubeDimMap.has(rff.refId)) ? true : (rff.isDim == undefined) ? true : null"
                            value="none">None
                    </option>
                    <option [attr.selected]="(cubeMesMap.has(rff.refId) || cubeDimMap.has(rff.refId)) && rff.isDim == false ? true : null"
                            value="measure">Measure
                    </option>
                    <option [attr.selected]="(cubeMesMap.has(rff.refId) || cubeDimMap.has(rff.refId)) && rff.isDim == true ? true : null"
                            value="dimension">Dimension
                    </option>
                </select>
            </div>
            <div *ngIf="isStarSchema && isDimMap.get(i)" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <select class="form-control p-1" id="dimcube" (change)="onSelectDimension($event, rff, i)" required>
                    <option value="" selected disabled hidden>Select here</option>
                    <option *ngFor="let dim of dimensionList"
                            [attr.selected]="dimMap.get(rff.refId) == dim.refId ? true : null"
                            [attr.value]="dim.refId">
                        {{dim.name}} ({{dim.dimCode}})
                    </option>
                </select>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 float-left">
                <input *ngIf="dimTimeMap.get(rff.refId)" #isdefaultDim type="checkbox"
                       [ngModel]='defaultTimeFilter == rff.refId ? true : null'
                       (change)="selectDefaultDim(isdefaultDim.checked,rff.refId)"/>
            </div>
            <div *ngIf="isStarSchema && isDimMap.get(i)"
                 class="col-lg-1 col-md-1 col-sm-2 col-xs-2 text-danger float-right" ngbTooltip="No Primary Key found">
                <i *ngIf="!(PkExistsMap.get(dimMap.get(rff.refId)))" style="pointer-events: none;color:red"
                   class="fa fa-exclamation-circle mr-2"></i>
            </div>
        </div>
    </ng-container>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/dataMapper.html